import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
} from '@angular/core';

/**
 * Emits when user clicks outside the element
 * Used to close dropdowns/menus when clicking elsewhere on the page
 */
@Directive({
  selector: '[fsClickOutside]',
  standalone: true,
})
export class VIClickOutsideDirective {
  private element = inject(ElementRef);

  @Input() fsClickOutsideIgnoredElements: HTMLElement[] = [];

  @Output() fsClickOutside = new EventEmitter<void>();

  @HostListener('document:mousedown', ['$event']) onMouseClick(event: MouseEvent) {
    this.handleMouseClick(event);
  }

  private handleMouseClick(event: MouseEvent): void {
    const target = event.target;
    if (!target || !(target instanceof Node)) {
      return;
    }

    const isClickingOutside = !this.element.nativeElement.contains(target);

    if (!isClickingOutside) {
      return;
    }

    const isClickingIgnoredElement = this.fsClickOutsideIgnoredElements.some((el) =>
      el.contains(target),
    );

    if (isClickingIgnoredElement) {
      return;
    }

    this.fsClickOutside.emit();
  }
}
